import u from "jquery";
import { Routing } from './routing';

export class Portfolio {
  static renderFolio(data) {
    return `<div class="element">
              <div class="hover btn-goto" data-url="${data.url}">
                  <div class="inside">
                      <div class="name">${data.name}</div>
                      <div class="desc">${data.description}</div>
                  </div>
              </div>
              <img src="${data.thumb}" alt="${data.name}"/>
          </div>`;
  }

  static renderLogo(data) {
    return `<div class="element"><img src="${data.image}" alt="${data.name}"/></div>`;
  };

  static renderFullFolio(data) {
    const $portfolio = u('.portfolio');
    u('header', $portfolio).css({backgroundImage: `url(${data.bg})`});
    u('header h1', $portfolio).html(data.name);
    u('header h2', $portfolio).html(data.description);
    let html = '';
    if(data.intro) {
      html += `<p>${data.intro}</p>`;
    }
    for(const i of data.images) {
      html += `<img src="${i}"/>`;
    }
    u('section', $portfolio).html(html);
  }

  static init() {
    fetch('portfolio.json').then(function (response) {
      return response.json();
    }).then(data => {
      Routing.addSubpages(data.portfolio);


      u('#portfolio .grid').html(data.portfolio.map(i => Portfolio.renderFolio(i)).join(''));
      u('#trusted .grid').html(data.logo.map(i => Portfolio.renderLogo(i)).join(''));
    });

    const $nav_elements = u('.navigation a');$nav_elements.on('click', (e) => {
      e.preventDefault();
      $nav_elements.removeClass('active');
      u(e.currentTarget).addClass('active');

      u('.element', '#portfolio').slice(1,3).toggle();
    });

  }
}
